import { useMutation, useQueryClient } from '@tanstack/react-query';
import { assumptionsSchema, type Assumptions, type AssumptionsInput } from '@app/shared';
import { apiFetch } from '@/lib/api';
import { assumptionsQueryOptions } from '@/features/simulations/queries';

function createAssumptions(input: AssumptionsInput): Promise<Assumptions> {
  return apiFetch('/api/assumptions', { method: 'POST', body: input, schema: assumptionsSchema });
}

/** Ajoute une version (append-only) et remplace celle que les simulateurs lisent. */
export function useCreateAssumptions() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createAssumptions,
    onSuccess: (saved) => queryClient.setQueryData(assumptionsQueryOptions.queryKey, saved),
  });
}
